<template>
  <div class="black">
    <v-container v-if="brands && $store.state.brands">
      <div class="my-6 text-h5 white--text text-center">
        Choose your favorite brand
      </div>
      <v-row dense>
        <v-col v-for="brand in brands" :key="brand" cols="6" lg="3">
          <v-card
            flat
            tile
            color="#0D0D0D"
            class="pa-12 pa-lg-16"
            :to="`/brand/${brand}`"
          >
            <v-img transition="scale-transition" :src="$store.state.brands[brand].logoUrl" contain aspect-ratio="1"></v-img>
          </v-card>
        </v-col>
      </v-row>
      <!-- <div class="d-flex flex-row-reverse mt-4">
        <v-btn plain color="white" x-large>All Brands</v-btn>
      </div> -->
      <div class="mt-12">
        <v-row justify="center" class="mt-2">
          <v-col cols="12">
            <v-text-field
              class="text-h5"
              placeholder="Search"
              height="60px"
              solo
              dark
              prepend-inner-icon="mdi-magnify"
              v-model="searchKey"
              @keydown.enter="search"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <div v-else class="holder" />
  </div>
</template>

<script>
import { doc, getDoc, getFirestore } from "firebase/firestore/lite"
export default {
  data() {
    return {
      searchKey: null,
      brands: undefined,
    }
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    async getBrands() {
      const ref = doc(getFirestore(), "apps/website")
      this.brands = (await getDoc(ref)).data().featuredBrands
    },
    search() {
      if (this.searchKey == null || this.searchKey.length == 0) {
        return
      }
      const key = this.searchKey.trim()
      if (key.length == 0) {
        return
      }
      this.$router.push({ name: "search", query: { q: key } })
    },
  },
}
</script>

<style scoped>
.holder {
  min-height: calc(100vh - 72px);
}
</style>
